module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh-CN":{"title":"查看详细评价","product_button_label":"查看该商品的所有评价"}}')
  delete Component.options._Ctor
}
